(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["advanced-collection-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__advancedCollectionFilter) return;

  const productMap = new Map();
  const normalize = value => String(value || '').trim().toLowerCase();
  let productsPromise;
  let refreshTimer;
  let runId = 0;

  const loadProducts = async () => {
    const root = document.querySelector('[data-advanced-collection]');
    if (!root) return;
    let page = 1;
    while (true) {
      const response = await fetch(`${root.dataset.collectionUrl}/products.json?limit=250&page=${page}`);
      if (!response.ok) throw new Error('Unable to load collection inventory');
      const payload = await response.json();
      payload.products.forEach(product => productMap.set(product.handle, product));
      if (payload.products.length < 250) break;
      page += 1;
    }
  };

  const ensureProducts = () => {
    productsPromise ||= loadProducts();
    return productsPromise;
  };

  const sizeOptionIndex = product => product.options.findIndex(option => normalize(option.name) === 'size');

  const hasAvailableSize = (product, selectedSizes) => {
    const optionIndex = sizeOptionIndex(product);
    if (optionIndex < 0) return false;
    return product.variants.some(variant => {
      const size = normalize(variant[`option${optionIndex + 1}`]);
      return variant.available && selectedSizes.includes(size);
    });
  };

  const updateCounts = () => {
    document.querySelectorAll('[data-advanced-size-filter] input[type="checkbox"]').forEach(input => {
      const size = normalize(input.value);
      let count = 0;
      productMap.forEach(product => {
        if (hasAvailableSize(product, [size])) count += 1;
      });
      const row = input.closest('li');
      const badge = row?.querySelector('.prcnt');
      if (badge) badge.textContent = `(${count})`;
      input.disabled = count === 0 && !input.checked;
      row?.classList.toggle('disabled', input.disabled);
      input.closest('label')?.classList.toggle('disabled', input.disabled);
    });
  };

  const selectedSizes = () => {
    return Array.from(document.querySelectorAll('[data-advanced-size-filter] input:checked')).map(input => normalize(input.value));
  };

  const pageUrl = page => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.toString();
  };

  const collectMatchingCards = async (sizes, currentRun) => {
    const cards = [];
    const seenHandles = new Set();
    let page = 1;
    while (true) {
      const response = await fetch(pageUrl(page), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to load filtered collection page');
      const html = await response.text();
      if (currentRun !== runId) return [];
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const pageCards = Array.from(parsed.querySelectorAll('.grid-products [data-advanced-product-handle]'));
      pageCards.forEach(card => {
        const handle = card.dataset.advancedProductHandle;
        const product = productMap.get(handle);
        if (!seenHandles.has(handle) && product && hasAvailableSize(product, sizes)) {
          seenHandles.add(handle);
          cards.push(card);
        }
      });
      const hasNextPage = parsed.querySelector('.infinitpaginOuter a[href], .pagination a[rel="next"], .pagination .next a[href]');
      if (!hasNextPage || pageCards.length === 0) break;
      page += 1;
    }
    return cards;
  };

  const renderAccurateResults = async () => {
    const root = document.querySelector('[data-advanced-collection]');
    const grid = document.querySelector('.grid-products.grid--view-items, .grid-products:not(.list-view-items)');
    if (!root || !grid) return;
    await ensureProducts();
    updateCounts();
    const sizes = selectedSizes();
    if (sizes.length === 0) return;
    const key = `${window.location.pathname}${window.location.search}|${sizes.join(',')}`;
    if (grid.dataset.advancedRenderedKey === key) return;
    const currentRun = ++runId;
    grid.setAttribute('aria-busy', 'true');
    const cards = await collectMatchingCards(sizes, currentRun);
    if (currentRun !== runId) return;
    grid.replaceChildren(...cards);
    grid.dataset.advancedRenderedKey = key;
    grid.removeAttribute('aria-busy');
    document.querySelectorAll('.infinitpaginOuter, .pagination').forEach(element => { element.hidden = true; });
    const productCount = document.querySelector('.filters-toolbar__product-count');
    if (productCount) productCount.textContent = `${cards.length} ${root.dataset.resultsText}`;
    let message = document.querySelector('[data-advanced-empty]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.advancedEmpty = '';
      message.className = 'tc';
      message.textContent = root.dataset.emptyText;
      grid.after(message);
    }
    message.hidden = cards.length > 0;
  };

  const scheduleRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => renderAccurateResults().catch(() => {}), 250);
  };

  window.__advancedCollectionFilter = true;
  ensureProducts().then(scheduleRefresh).catch(() => {});
  document.addEventListener('change', event => {
    if (event.target.closest?.('#CollectionFiltersForm')) setTimeout(scheduleRefresh, 350);
  });
  window.addEventListener('popstate', scheduleRefresh);
  new MutationObserver(scheduleRefresh).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["connect-with-us"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = new WeakSet();
    let activeRoot = null;
    let lastFocusedElement = null;

    const socialOrder = ['instagram', 'facebook', 'youtube', 'whatsappChannel', 'pinterest'];

    const getConfig = (root) => {
      if (root.mmConnectConfig) return root.mmConnectConfig;

      const configNode = root.querySelector('[data-mm-connect-config]');
      let config = {};

      try {
        config = JSON.parse(configNode?.textContent || '{}');
      } catch (error) {
        config = {};
      }

      root.mmConnectConfig = {
        ...config,
        followerCounts: config.followerCounts || {},
        socialLinks: config.socialLinks || {},
      };

      return root.mmConnectConfig;
    };

    const prepareRoot = (root) => {
      if (root.dataset.mmPrepared === 'true') return;

      const config = getConfig(root);

      root.querySelectorAll('[data-mm-follower-count]').forEach((node) => {
        const key = node.getAttribute('data-mm-follower-count');
        if (config.followerCounts[key]) {
          node.textContent = config.followerCounts[key];
        }
      });

      root.dataset.mmPrepared = 'true';
    };

    const getFocusable = (container) => {
      const selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(',');

      return Array.from(container.querySelectorAll(selector)).filter((element) => {
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    };

    const openModal = (root) => {
      prepareRoot(root);

      const overlay = root.querySelector('[data-mm-connect-overlay]');
      const dialog = root.querySelector('[data-mm-dialog]');
      if (!overlay || !dialog) return;

      if (activeRoot && activeRoot !== root) {
        closeModal(activeRoot, false);
      }

      lastFocusedElement = document.activeElement;
      activeRoot = root;

      overlay.hidden = false;
      document.documentElement.classList.add('mm-connect-lock');
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        const preferredFocus = root.querySelector('[data-mm-whatsapp]') || dialog;
        preferredFocus.focus({ preventScroll: true });
      });
    };

    const closeModal = (root, restoreFocus = true) => {
      const overlay = root.querySelector('[data-mm-connect-overlay]');
      if (!overlay || overlay.hidden) return;

      overlay.classList.remove('is-open');
      window.setTimeout(() => {
        overlay.hidden = true;
        if (activeRoot === root) {
          activeRoot = null;
          document.documentElement.classList.remove('mm-connect-lock');
        }

        if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }, 220);
    };

    const trapFocus = (event) => {
      if (!activeRoot || event.key !== 'Tab') return;

      const dialog = activeRoot.querySelector('[data-mm-dialog]');
      const focusable = dialog ? getFocusable(dialog) : [];
      if (!focusable.length) {
        event.preventDefault();
        dialog?.focus({ preventScroll: true });
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const readProduct = (root) => {
      const productNode = root.querySelector('[data-mm-product-json]');
      if (!productNode) return null;

      try {
        return JSON.parse(productNode.textContent || 'null');
      } catch (error) {
        return null;
      }
    };

    const getProductForm = (root) => {
      return root.closest('section')?.querySelector('form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
    };

    const getSelectedVariantId = (root) => {
      const form = getProductForm(root);
      const variantInput = form?.querySelector('[name="id"]');
      return String(variantInput?.value || root.dataset.selectedVariantId || '');
    };

    const getSelectedVariant = (root, product) => {
      const selectedVariantId = getSelectedVariantId(root);
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      return variants.find((variant) => String(variant.id) === selectedVariantId) || null;
    };

    const formatMoney = (root, cents) => {
      if (typeof cents !== 'number') return root.dataset.selectedVariantPrice || '';

      const currency = root.dataset.currency || window.Shopify?.currency?.active || 'INR';
      const locale = document.documentElement.lang || navigator.language || 'en-IN';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch (error) {
        return `${currency} ${(cents / 100).toFixed(2)}`;
      }
    };

    const getProductUrl = (root, variant) => {
      const baseUrl = root.dataset.productUrl || window.location.href;
      let url;

      try {
        url = new URL(baseUrl, window.location.origin);
      } catch (error) {
        url = new URL(window.location.href);
      }

      if (variant?.id) {
        url.searchParams.set('variant', variant.id);
      }

      return url.toString();
    };

    const buildWhatsAppMessage = (root) => {
      const product = readProduct(root);
      const variant = getSelectedVariant(root, product);
      const productTitle = product?.title || root.dataset.productTitle || document.title;
      const variantTitle = variant?.title || root.dataset.selectedVariantTitle || '';
      const variantPrice = formatMoney(root, variant?.price);
      const productUrl = getProductUrl(root, variant);
      const lines = [
        'Hi Modern Marwar, I need help with this product:',
        `Product: ${productTitle}`,
      ];

      if (variantTitle && variantTitle !== 'Default Title') {
        lines.push(`Variant: ${variantTitle}`);
      }

      if (variantPrice) {
        lines.push(`Price: ${variantPrice}`);
      }

      lines.push(`Link: ${productUrl}`);
      lines.push('Please assist me.');

      return lines.join('\n');
    };

    const openWhatsApp = (root) => {
      const config = getConfig(root);
      const number = String(config.whatsAppNumber || '').replace(/\D/g, '');
      const message = encodeURIComponent(buildWhatsAppMessage(root));
      const url = number ? `https://wa.me/${number}?text=${message}` : `https://wa.me/?text=${message}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    const followAll = (root) => {
      const config = getConfig(root);
      const fallbackLinks = Array.from(root.querySelectorAll('.mm-connect__follow')).map((link) => link.href);
      const configLinks = socialOrder.map((key) => config.socialLinks[key]).filter(Boolean);
      const links = configLinks.length ? configLinks : fallbackLinks;

      links.forEach((url, index) => {
        if (!url) return;

        const tab = window.open('', '_blank');
        if (tab) {
          tab.opener = null;
          window.setTimeout(() => {
            tab.location.href = url;
          }, index * 140);
          return;
        }

        window.setTimeout(() => {
          window.open(url, '_blank', 'noopener,noreferrer');
        }, index * 140);
      });
    };

    const addRipple = (target, event) => {
      const rect = target.getBoundingClientRect();
      const ripple = document.createElement('span');
      const x = event.clientX ? event.clientX - rect.left : rect.width / 2;
      const y = event.clientY ? event.clientY - rect.top : rect.height / 2;

      ripple.className = 'mm-connect-ripple';
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      target.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    };

    const onRootClick = (event) => {
      const root = event.currentTarget;
      const rippleTarget = event.target.closest('[data-mm-ripple]');

      if (rippleTarget && root.contains(rippleTarget)) {
        addRipple(rippleTarget, event);
      }

      if (event.target.closest('[data-mm-open]')) {
        openModal(root);
        return;
      }

      if (event.target.closest('[data-mm-close]') || event.target === root.querySelector('[data-mm-connect-overlay]')) {
        closeModal(root);
        return;
      }

      if (event.target.closest('[data-mm-whatsapp]')) {
        event.preventDefault();
        openWhatsApp(root);
        return;
      }

      if (event.target.closest('[data-mm-follow-all]')) {
        event.preventDefault();
        followAll(root);
      }
    };

    const onDocumentKeydown = (event) => {
      if (!activeRoot) return;

      if (event.key === 'Escape') {
        closeModal(activeRoot);
        return;
      }

      trapFocus(event);
    };

    const init = () => {
      document.querySelectorAll('[data-mm-connect-root]').forEach((root) => {
        if (roots.has(root)) return;
        roots.add(root);
        root.addEventListener('click', onRootClick);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('keydown', onDocumentKeydown);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["floating-share-widget"] && !Shopify.designMode) return;
  try {
    (function() {
    function runAfterFirstPaint(callback) {
      var schedule = function() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, { timeout: 1200 });
          return;
        }

        window.setTimeout(callback, 250);
      };

      if (document.readyState === 'complete') {
        schedule();
        return;
      }

      window.addEventListener('load', schedule, { once: true });
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise(function(resolve, reject) {
        var input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '-1000px';
        document.body.appendChild(input);
        input.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        }

        document.body.removeChild(input);
      });
    }

    function initFloatingSocial(container) {
      container.querySelectorAll('[data-mm-floating-social]').forEach(function(root) {
        if (root.dataset.mmFloatingReady) return;

        root.dataset.mmFloatingReady = 'true';

        var toggles = root.querySelectorAll('[data-mm-panel-toggle]');
        var panels = root.querySelectorAll('[data-mm-panel]');
        var shareButton = root.querySelector('[data-mm-native-share]');
        var shareUrl = root.getAttribute('data-share-url') || window.location.href;
        var shareTitle = root.getAttribute('data-share-title') || document.title;

        function closePanels() {
          panels.forEach(function(panel) {
            panel.hidden = true;
          });

          toggles.forEach(function(toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          });
        }

        function showCopied() {
          if (!shareButton) return;

          shareButton.classList.add('is-copied');

          window.setTimeout(function() {
            shareButton.classList.remove('is-copied');
          }, 1500);
        }

        function fallbackCopy() {
          copyText(shareUrl).then(showCopied);
        }

        toggles.forEach(function(toggle) {
          toggle.addEventListener('click', function(event) {
            event.stopPropagation();
            var panelName = toggle.getAttribute('data-mm-panel-toggle');
            var panel = root.querySelector('[data-mm-panel="' + panelName + '"]');
            if (!panel) return;

            var shouldOpen = panel.hidden;
            closePanels();
            panel.hidden = !shouldOpen;
            toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          });
        });

        if (shareButton) {
          shareButton.addEventListener('click', function(event) {
            event.stopPropagation();
            closePanels();

            if (navigator.share) {
              navigator.share({ title: shareTitle, url: shareUrl }).catch(function(error) {
                if (error && error.name === 'AbortError') return;
                fallbackCopy();
              });
              return;
            }

            fallbackCopy();
          });
        }

        document.addEventListener('click', function(event) {
          if (!root.contains(event.target)) closePanels();
        });

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') closePanels();
        });

        root.classList.add('is-ready');
      });
    }

    runAfterFirstPaint(function() {
      initFloatingSocial(document);
    });

    document.addEventListener('shopify:section:load', function(event) {
      initFloatingSocial(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["support-chat-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    var root = document.getElementById('mm-support-chat');
    if (!root) return;

    var CFG = {};
    try {
      var cfgEl = root.querySelector('[data-mm-chat-config]');
      if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
    } catch (error) {
      CFG = {};
    }
    var STRINGS = CFG.strings || {};
    var PROXY_PATH = CFG.proxyPath || '/apps/billing';
    var POLL_INTERVAL_MS = CFG.pollIntervalMs || 8000;

    var bubble = root.querySelector('[data-mm-chat-open]');
    var overlay = root.querySelector('[data-mm-chat-overlay]');
    var dialog = root.querySelector('[data-mm-chat-dialog]');
    var closeButton = root.querySelector('[data-mm-chat-close]');
    var messagesEl = root.querySelector('[data-mm-chat-messages]');
    var form = root.querySelector('[data-mm-chat-form]');
    var input = root.querySelector('[data-mm-chat-input]');
    var sendButton = root.querySelector('[data-mm-chat-send]');

    var isLoggedIn = root.dataset.mmLoggedIn === 'true';
    var lastFocusedElement = null;
    var pollTimer = null;
    var renderedMessageIds = {};

    function apiUrl(action, params) {
      var query = ['action=' + encodeURIComponent(action)];
      if (params) {
        Object.keys(params).forEach(function(key) {
          if (params[key] === undefined || params[key] === null || params[key] === '') return;
          query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
        });
      }
      // Same fix already proven necessary for the billing portal: Shopify's
      // App Proxy redirect has no Cache-Control header, so browsers can
      // cache and replay a now-expired signed URL without a unique param.
      query.push('_=' + Date.now());
      return PROXY_PATH + '?' + query.join('&');
    }

    function callApi(action, params) {
      return fetch(apiUrl(action, params), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function(response) {
        return response.json().catch(function() { return {}; }).then(function(body) {
          if (!response.ok) {
            var error = new Error((body && (body.message || body.exception)) || 'Request failed');
            error.body = body;
            throw error;
          }
          return body && body.message !== undefined ? body.message : body;
        });
      });
    }

    // Shopify's App Proxy 301-redirects every request to the signed backend
    // URL -- GET or POST, fetch or real navigation, it doesn't matter. Per
    // standard redirect semantics that always converts a POST to a GET on
    // the follow-up request, silently dropping the body. So chat_send must
    // travel as a GET with the message in the query string (same as every
    // other action here, including chat_history) rather than a POST body --
    // there is no way to carry a POST body through this proxy reliably.
    function sendMessage(text) {
      return callApi('chat_send', { message: text });
    }

    function loadHistory() {
      return callApi('chat_history');
    }

    function showError(error) {
      var text = STRINGS.error || 'Something went wrong.';
      var raw = error && error.body && (error.body.message || error.body.exception);
      if (raw && String(raw).toLowerCase().indexOf('log in') !== -1) {
        text = STRINGS.please_log_in || text;
      }
      var el = document.createElement('p');
      el.className = 'mm-chat__empty';
      el.textContent = text;
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function buildAttachmentNode(attachment) {
      var isVideo = /\.(mp4|mov|webm|m4v)$/i.test(attachment.file_name || '');
      var el = document.createElement(isVideo ? 'video' : 'img');
      el.src = attachment.file_url;
      if (isVideo) {
        el.controls = true;
      } else {
        el.alt = attachment.file_name || '';
      }
      return el;
    }

    function renderMessages(data) {
      var messages = (data && data.messages) || [];
      if (!messages.length) {
        if (!messagesEl.childElementCount) {
          var empty = document.createElement('p');
          empty.className = 'mm-chat__empty';
          empty.textContent = STRINGS.empty || "Send us a message and we'll get back to you shortly.";
          messagesEl.appendChild(empty);
        }
        return;
      }

      var hasNew = false;
      messages.forEach(function(message) {
        if (renderedMessageIds[message.name]) return;
        hasNew = true;
        renderedMessageIds[message.name] = true;

        if (messagesEl.querySelector('.mm-chat__empty')) {
          messagesEl.innerHTML = '';
        }

        var bubbleEl = document.createElement('div');
        bubbleEl.className = 'mm-chat__bubble-msg mm-chat__bubble-msg--' +
          (message.sent_or_received === 'Sent' ? 'sent' : 'received');
        bubbleEl.textContent = '';
        bubbleEl.innerHTML = message.content || '';

        (message.attachments || []).forEach(function(attachment) {
          bubbleEl.appendChild(buildAttachmentNode(attachment));
        });

        messagesEl.appendChild(bubbleEl);
      });

      if (hasNew) {
        messagesEl.scrollTop = messagesEl.scrollHeight;
      }
    }

    function refreshHistory() {
      loadHistory().then(renderMessages).catch(function() {});
    }

    function stopPolling() {
      if (pollTimer) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }

    function startPolling() {
      stopPolling();
      pollTimer = window.setInterval(function() {
        if (!overlay.classList.contains('is-open')) return;
        refreshHistory();
      }, POLL_INTERVAL_MS);
    }

    function getFocusable(container) {
      var selector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.prototype.slice.call(container.querySelectorAll(selector)).filter(function(element) {
        var style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
    }

    function trapFocus(event) {
      if (event.key !== 'Tab' || !overlay.classList.contains('is-open')) return;
      var focusable = getFocusable(dialog);
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openPanel() {
      lastFocusedElement = document.activeElement;
      overlay.hidden = false;
      document.documentElement.classList.add('mm-chat-lock');
      window.requestAnimationFrame(function() {
        overlay.classList.add('is-open');
        if (input) input.focus({ preventScroll: true });
      });
      if (isLoggedIn) {
        refreshHistory();
        startPolling();
      }
    }

    function closePanel() {
      overlay.classList.remove('is-open');
      stopPolling();
      window.setTimeout(function() {
        overlay.hidden = true;
        document.documentElement.classList.remove('mm-chat-lock');
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }, 220);
    }

    bubble.addEventListener('click', openPanel);
    closeButton.addEventListener('click', closePanel);
    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) closePanel();
    });
    document.addEventListener('keydown', function(event) {
      if (!overlay.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closePanel();
        return;
      }
      trapFocus(event);
    });
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopPolling();
      } else if (overlay.classList.contains('is-open')) {
        // A customer very commonly tabs away while waiting for a reply.
        // Restarting the interval alone means the first refresh doesn't
        // land until a full POLL_INTERVAL_MS after they come back --
        // fetch immediately on refocus so a reply sent while they were
        // away shows up the instant they return, not on the next tick.
        refreshHistory();
        startPolling();
      }
    });

    if (isLoggedIn && form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var text = input.value.trim();
        if (!text) return;

        sendButton.disabled = true;
        sendMessage(text)
          .then(function() {
            input.value = '';
            refreshHistory();
          })
          .catch(showError)
          .finally(function() {
            sendButton.disabled = false;
          });
      });

      input.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          form.requestSubmit();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
